import React from 'react';

const items = [
  {
    bg: 'bg-[#5c2d91]',
    content: (
      <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 normal-case">
        <span className="text-center uppercase leading-tight">Nationwide delivery via</span>
        <span className="inline-flex items-center gap-2">
          <img
            src="/lazada-logo.png"
            alt=""
            className="h-5 w-auto shrink-0 opacity-95 sm:h-6"
            width={24}
            height={24}
            aria-hidden
          />
          <span className="opacity-90" aria-hidden>
            &amp;
          </span>
          <img
            src="/shopee-logo.svg"
            alt=""
            className="h-5 w-auto shrink-0 sm:h-6"
            width={24}
            height={24}
            aria-hidden
          />
        </span>
        <span className="sr-only">Lazada and Shopee</span>
      </span>
    )
  },
  { bg: 'bg-[#8cc63f]', label: 'Same-day delivery · Davao Province only' },
  { bg: 'bg-[#2563eb]', label: 'Quality products · trusted suppliers' }
];

export default function AnnouncementBar() {
  return (
    <div className="flex w-full overflow-hidden text-[10px] font-bold uppercase tracking-wider text-white sm:text-xs">
      {items.map((item) => (
        <div
          key={item.bg + (item.label ?? 'marketplaces')}
          className={`flex min-h-10 flex-1 items-center justify-center px-2 py-2 sm:min-h-0 sm:px-4 sm:py-2.5 ${item.bg}`}
        >
          {item.content ?? (
            <span className="text-center leading-tight">{item.label}</span>
          )}
        </div>
      ))}
    </div>
  );
}
